// extracted by mini-css-extract-plugin
module.exports = {"disableModalText":"disableModalText--QvQ2K"};